import apiClient from "./client";
import { getUserId } from "../analytics";

const isObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);

const normalizeNewsletterResponse = (data) => {
  if (!isObject(data) || !isObject(data.newsletter)) {
    return data;
  }

  return {
    ...data,
    ...data.newsletter,
  };
};

// Submit newsletter signup
export const submitNewsletterSignup = async (email, token = null, sourceSurface = 'unknown') => {
  try {
    const userId = getUserId();
    if (!userId) {
      throw new Error('No user ID found');
    }

    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await apiClient.post(
      `/newsletter/signup`,
      {
        email: email.trim(),
        source_surface: sourceSurface,
      },
      { headers }
    );
    
    return normalizeNewsletterResponse(response.data);
  } catch (error) {
    console.error("Error submitting newsletter signup:", error);
    throw error;
  }
};

// Get subscriber count
export const getSubscriberCount = async () => {
  try {
    const response = await apiClient.get('/newsletter/subscribers/count');
    return response.data.count;
  } catch (error) {
    console.error("Error fetching subscriber count:", error);
    throw error;
  }
};

// Unsubscribe from newsletter
export const unsubscribeNewsletter = async (email, token = null, sourceSurface = 'unknown') => {
  try {
    const userId = getUserId();
    if (!userId) {
      throw new Error('No user ID found');
    }

    const headers = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await apiClient.post(
      `/newsletter/unsubscribe`,
      {
        email: email.trim(),
        source_surface: sourceSurface,
      },
      { headers }
    );
    
    return normalizeNewsletterResponse(response.data);
  } catch (error) {
    console.error("Error unsubscribing from newsletter:", error);
    throw error;
  }
};
